module.exports = __webpack_public_path__ + "static/media/history-10.ed787165.jpg";